module.exports = __webpack_public_path__ + "static/interactive-brokers-81c93f222177dd72e4ea444a4c91eb84.png";